<template>
<v-container fluid>
    <material-card title="Auto Allocation Configuration" inline icon="mdi-mail">
      <!-- <v-card-actions>
        <router-link slot="right" :to="{ name: 'leadManagement' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions> -->

      <form name="updateSettings" @submit.prevent="saveConfiguration">
        <div>
          <v-card-component>
<v-row>
        <v-col cols="12">
          <v-row>
<v-col cols="12" lg="4" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="time" aria-required="true" label="Auto allocation cut-off" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu2" v-model="time" full-width format="24hr" @click:minute="$refs.menu.save(time)"></v-time-picker>
                </v-menu>
              </v-col>
            <!-- <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Auto allocation cut-off</span>
              <span class="error--text ml-1">*</span>
              <v-text-field type="time" placeholder=""
                v-model="autoAllocationCutOff" class="my-0 py-1" required
                single-line>
              </v-text-field>
            </v-col> -->
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Fresh Leads</span>
<span class="error--text ml-1">*</span>
              <v-text-field type="number" placeholder=""
                v-model="freshLeads" required class="my-0 py-1" autocomplete="off"></v-text-field>
            </v-col>
<v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Follow-up Leads</span> <span class="error--text ml-1">*</span>
              <v-text-field type="number" placeholder="" required
                v-model="followUpLeads" class="my-0 py-1" autocomplete="off"></v-text-field>
            </v-col>

          </v-row>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Max Lead Count </span>
          <span class="error--text">*</span>
          <v-text-field type="number" placeholder="" min="0"
                v-model="maxLeadCount" required class="my-0 py-1" autocomplete="off"></v-text-field>
        </v-col>

      </v-row>
</v-card-component>
        <v-card-actions class="d-flex justify-end">
          <v-btn bottom :disabled="hasClicked" right elevation="1" color="primary" type="submit">
            <v-icon left> mdi-content-save </v-icon>
            Save
          </v-btn>
        </v-card-actions>
        </div>

      </form>

    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>

</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'

export default {
  name: 'AutoAllocationConfig',
  props: ['allocationId'],
  components: {
    VCardComponent,
    MaterialCard
  },
  data: function () {
    return {
      enquiry: {},
      cardTitle: '',
      cardIcon: '',
      time: null,
      autoAllocationCutOff: '',
      freshLeads: '',
      followUpLeads: '',
      maxLeadCount: '',
      menu2: false,
      hasClicked: false,
      loader: true,
      formData: {},
      message: 'true',
      isLoaded: 'false',
      isLoading: false,
      callAttemptCount: 1,
      autoAllocationDetails: {},
      timepicker: {
        incrementMinutes: 15
      }
    }
  },
  async created () {
    if (this.allocationId) {
      await this.getAutoAllocationDetails(this.allocationId)
    }
  },
  watch: {
    freshLeads: async function (val) {
      let freshLeads = val
      console.log('freshLeads-->', val)
      if (freshLeads > 100) {
        this.freshLeads = 100
        let errorMessage = 'Value should be less than equal to 100'
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } else {
        this.followUpLeads = (parseInt(100) - parseInt(freshLeads))
      }
    },
    followUpLeads: async function (val) {
      let followUpLeads = val
      if (followUpLeads > 100) {
        this.followUpLeads = 100
        let errorMessage = 'Value should be less than equal to 100'
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } else {
        this.freshLeads = (parseInt(100) - parseInt(followUpLeads))
      }
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getAutoAllocationDetails: async function (allocateID) {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/autoallocationconfig`, {
          params: {
            allocationID: allocateID
          }
        })

        let autoAllocationDetails = data
        if (autoAllocationDetails) {
          autoAllocationDetails.filter(obj => {
            this.time = this.autoAllocationCutOff = obj.autoAllocationCutOff
            this.freshLeads = obj.freshLeads
            this.followUpLeads = obj.followUpLeads
            this.maxLeadCount = obj.maxLeadCount
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching auto allocation details : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    saveConfiguration: async function () {
      try {
        this.hasClicked = true
        this.loader = true
        this.loadingComponent = this.$buefy.loading.open()

        let inputData = {
          autoAllocationCutOff: this.time,
          freshLeads: this.freshLeads,
          followUpLeads: this.followUpLeads,
          maxLeadCount: this.maxLeadCount,
          allocationID: this.allocationId
        }

        await http.post(`${constants.API_URL}/api/update-autoAllocationConfig`,
          inputData)
        this.loader = false
        this.$router.push({ name: 'leadManagement' })
        this.loadingComponent.close()

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Record updated successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        console.log('Error While updating call attempt count details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loadingComponent.close()

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
